import { useRef } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const useId = () => {
  const idRef = useRef<string>()
  if (!idRef.current) {
    idRef.current = uuidv4()
  }
  return idRef.current
}
